module.exports = __webpack_public_path__ + "img/american_express.e5bf0c8d.svg";